<template>

    <div class="login-section">

        <div class="login-wrapper">

            <div class="bg" style="background-image: url('img/login/background-image.png')"></div>

            <div class="website-logo text-center">
                <img class="logo-big" src="img/login/logo-2.png" alt="">
                <img class="logo-small" src="img/login/logo.png" alt="">
            </div>

            <div class="login-content-wrapper">

                <div class="login-content">

                    <div class="row">
                        <div class="col-4">
                            <span class="process-step" v-bind:class="checkStep('1')">&nbsp;</span>
                        </div>
                        <div class="col-4">
                            <span class="process-step" v-bind:class="checkStep('2')">&nbsp;</span>
                        </div>
                        <div class="col-4">
                            <span class="process-step" v-bind:class="checkStep('3')">&nbsp;</span>
                        </div>
                    </div>

                    <section v-if="step === 1">

                        <h4 class="w-medium">{{ $t('SIGNUP.STEP1.TITLE') }}</h4>

                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('SIGNUP.STEP1.INPUT_EMAIL') }}</label>
                            <input class="form-control" v-model="uniqueIdentifier" autocomplete="off" type="text"
                                   name="email" required="">
                        </div>

                        <div>
                            <button v-on:click="sendActivation" class="btn btn-fill btn-primary">
                                {{ $t('SIGNUP.STEP1.NEXT')}}
                            </button>
                        </div>
                        <div class="mt-4">
                            <router-link :to="{ name: 'Login' }">
                                {{ $t('SIGNUP.STEP1.BACK')}}
                            </router-link>
                        </div>
                    </section>

                    <section v-if="step === 2">


                        <h4 class="w-medium">{{ $t('SIGNUP.STEP2.TITLE') }}</h4>
                        <p class="w-medium">
                            {{ $t('SIGNUP.STEP2.INFORMATION') }}
                        </p>

                        <p class="w-medium">
                            {{ $t('SIGNUP.STEP2.INPUT_CODE')}}
                            <input class="form-control verificationCode" type="number" autocomplete="off" v-model="verificationCode"
                                   ref="verification"
                                   @keypress="verifyCode"/>
                        </p>
                        <h4 class="w-medium">{{ $t('SIGNUP.STEP2.NO_CODE') }}</h4>
                        <p>
                            <button v-on:click="getNewVerificationCode" class="btn btn-fill btn-primary">
                                {{ $t('SIGNUP.STEP2.GET_CODE') }}
                            </button>
                        </p>

                        <div class="mt-4">
                            <router-link :to="{ name: 'Login' }">
                                {{ $t('SIGNUP.STEP2.BACK')}}
                            </router-link>
                        </div>

                    </section>

                    <section v-if="step === 3">

                        <h4 class="w-medium">{{ $t('SIGNUP.STEP3.TITLE') }}</h4>
                        <p class="w-medium">
                            {{ $t('SIGNUP.STEP3.INFORMATION') }}
                        </p>

                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('SIGNUP.STEP3.INPUT_NAME') }}</label>
                            <input class="form-control" autocomplete="off" v-model="fullName" type="text" name="fullName" />
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('SIGNUP.STEP3.INPUT_PASSWORD') }}</label>
                            <input class="form-control" autocomplete="off" v-model="password" type="password" name="password1" />
                            <span @click="switchVisibility" class="clickable fa fa-fw fa-eye field-icon"></span>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('SIGNUP.STEP3.INPUT_TEAM') }}</label>
                            <input class="form-control" autocomplete="off" v-model="teamName" type="text" name="team"
                                   required="">
                        </div>
                        <div>
                            <button v-on:click="sendSignup" class="btn btn-fill btn-primary">
                                {{ $t('SIGNUP.STEP3.NEXT')}}
                            </button>
                        </div>
                        <div class="mt-4">
                            <a href="#" v-on:click="gotoBack">
                                {{ $t('SIGNUP.STEP3.BACK')}}
                            </a>
                        </div>
                    </section>

                    <LocaleLogin></LocaleLogin>

                </div>

            </div>
        </div>

    </div>

</template>
<script>
    import LocaleLogin from '@/components/Layout/LocaleLogin'

    export default {
        components: {
            LocaleLogin
        },
        data() {
            return {
                errorMessage: ''
                , image: 'img/login-image.png'
                , uniqueIdentifier: ''
                , verificationCode: ''
                , invitationCode: ''
                , fullName: ''
                , password: ''
                , teamName: ''
                , step: 1
                , passwordFieldType: 'password'
            }
        },
        methods: {
            checkStep: function (checkStep) {
                let result = [];
                if (checkStep == this.step) {
                    result.push('active');
                }
                return result;
            },
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            verifyCode: function ($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
                    $event.preventDefault();
                }
                if (this.verificationCode.length > 5) {
                    $event.preventDefault();
                }
            },
            gotoBack: function () {
                this.step = 1;
                self.verificationCode = '';
                self.invitationCode = '';
            },
            sendActivation: function () {
                localStorage.setItem("uui", this.uniqueIdentifier);
                let self = this;
                this.$http.post(process.env.VUE_APP_BACKEND + `/signup/get-activationcode`, {
                    email: this.uniqueIdentifier
                }).then(result => {
                    self.step = 2;
                    self.verificationCode = '';
                    self.invitationCode = result.data;
                    setTimeout(self.setFocus(), 600);
                }).catch(error => {
                    self.$noty.error(self.$t(error.response.data));
                });
            },
            getNewVerificationCode: function () {
                this.loading = true;
                let self = this;
                this.$http.post(process.env.VUE_APP_BACKEND + `/signup/new-activationcode`, {
                    email: this.uniqueIdentifier
                }).then(result => {
                    self.invitationCode = result.data;
                    self.verificationCode = '';
                    self.$noty.info(self.$t("SIGNUP.SUCCESS.NEW_CODE"));
                }).catch(error => {
                    self.$noty.error(self.$t(error.response.data));
                });
            },
            sendSignup: function () {
                this.loading = true;
                let self = this;
                this.$http.post(process.env.VUE_APP_BACKEND + `/signup/activate`, {
                    verificationCode: this.verificationCode,
                    invitationCode: this.invitationCode,
                    password: this.password,
                    name: this.fullName,
                    teamName: this.teamName
                }).then(function () {
                    self.$router.push('dashboard');
                }).catch(error => {
                    self.$noty.error(self.$t(error.response.data));
                });

            },
            isFocused: function () {
                if (this.showVerify === true) {
                    setTimeout(self.setFocus(), 600);
                }
            }
        },
        watch: {
            verificationCode: function () {
                if (this.verificationCode.length === 6) {
                    let self = this;
                    this.$http.post(process.env.VUE_APP_BACKEND + `/signup/verify`, {
                        verificationCode: this.verificationCode,
                        invitationCode: this.invitationCode
                    }).then(function () {
                        self.step = 3;
                    }).catch(error => {
                        self.$noty.error(self.$t(error.response.data));
                    });
                }
            }
        },
        created() {
            if (localStorage.getItem("uui") !== null) {
                this.uniqueIdentifier = localStorage.getItem("uui");
            }
            if (this.$route.query.code !== undefined) {
                this.invitationCode = this.$route.query.code;
                this.step = 2;
            }
        }
    }
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>